import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [emojiIndex, setEmojiIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const emojis = ['❤️', '☕', '🧮', '🧠', '💻', '💾', '🤖'];
  
  useEffect(() => {
    const interval = setInterval(() => {
      setPrevIndex(emojiIndex);
      setIsAnimating(true);
      
      setTimeout(() => {
        setEmojiIndex((current) => (current + 1) % emojis.length);
      }, 250); // Change emoji halfway through the animation
      
      setTimeout(() => {
        setIsAnimating(false);
      }, 500); // Reset animation state after it completes
    }, 10000);

    return () => clearInterval(interval);
  }, [emojiIndex, emojis.length]);

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="footer-links">
          <Link to="/contact" className="footer-link">Contact</Link>
          <Link to="/faq" className="footer-link">FAQ</Link>
        </div>
        <span className="location-text">
          Made with
          <span className="emoji-container">
            {isAnimating && <span className="emoji roll-out">{emojis[prevIndex]}</span>}
            <span className={`emoji ${isAnimating ? 'roll-in' : ''}`}>
              {emojis[emojiIndex]}
            </span>
          </span>
          in Denver, CO
        </span>
        <span className="copyright">&copy; {new Date().getFullYear()} Odikai</span>
      </div>
    </footer>
  );
}
